module.exports = __webpack_public_path__ + "static/media/wizualizacja-83.c568a046.png";